/** Central product branding — update here for site-wide consistency. */
export const BRAND = {
  name: 'Aurieq',
  nameUpper: 'AURIEQ',
  tagline: 'AI-powered social content, on your schedule',
  since: 'SINCE 2026',
  description:
    'Create, schedule, and publish engaging social media posts across LinkedIn, X, and Instagram with AI — all from one place.',
  domain: 'aurieq.com',
  url: 'https://aurieq.com',
  supportEmail: 'hello@aurieq.com',
  colors: {
    bg: '#05070a',
    bgElevated: '#0B0E14',
    surface: '#111827',
    surfaceHover: '#1a2234',
    primary: '#00D4FF',
    primaryDark: '#0033FF',
    secondary: '#6366F1',
    text: '#FFFFFF',
    textMuted: 'rgba(148, 163, 184, 0.92)',
    textDim: 'rgba(148, 163, 184, 0.65)',
    border: 'rgba(0, 212, 255, 0.12)',
    glow: 'rgba(0, 212, 255, 0.35)',
  },
  gradient: 'linear-gradient(135deg, #0033FF 0%, #00D4FF 100%)',
  gradientSoft: 'linear-gradient(135deg, rgba(0,51,255,0.25) 0%, rgba(0,212,255,0.15) 100%)',
  assets: {
    iconMark: '/brand/icon-mark-transparent.png',
    logoFull: '/brand/logo-full-transparent.png',
    logoOnBlack: '/logo-full-on-black.png',
    wordmark: '/wordmark-only-transparent.png',
    favicon: '/icons/favicon.ico',
    ogImage: '/social/og-image-1200x630.png',
  },
} as const;

export const PUBLIC_NAV = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
] as const;

export const FOOTER_LINKS = {
  product: [
    { label: 'Get started', path: '/register' },
    { label: 'Sign in', path: '/login' },
  ],
  legal: [
    { label: 'Privacy Policy', path: '/privacy' },
    { label: 'Terms & Conditions', path: '/terms' },
  ],
  company: [
    { label: 'About', path: '/about' },
    { label: 'Contact', path: '/contact' },
  ],
} as const;
